/* unplugin-vue-components disabled */import { render } from "./CheckoutConfirm.vue?vue&type=template&id=4ca03ae4"
const script = {}

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__